module.exports = __webpack_public_path__ + "img/newsbackground-placeholder.087c1dca.jpg";